export function attachCsrfToken(event) {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

  if (!token) return;

  event.detail.headers["X-CSRF-Token"] = token;
}

export function rotateCsrfToken(event) {
  const xhr = event.detail?.xhr;

  if (!xhr) return;

  const newToken = xhr.getResponseHeader("X-CSRF-Token");

  if (!newToken) return;

  const meta = document.querySelector('meta[name="csrf-token"]');

  if (!meta) return;

  meta.setAttribute("content", newToken);
}
